import { motion } from "framer-motion";
import { Star, Quote, BadgeCheck } from "lucide-react";

const REVIEWS = [
  {
    name: "Marko Petrović",
    car: "Audi A6 3.0 TDI",
    comment: "Šlep služba AutoBay me spasila u 2 ujutru na autoputu kod Niša. Kamion stigao za pola sata, utovar bez greške i vožnja direktno u radionicu. Sve preporuke!",
    rating: 5.0,
    service: "Šlep 24/7",
  },
  {
    name: "Jelena Nikolić",
    car: "Škoda Octavia",
    comment: "Zamena ulja i filtera urađena za sat vremena, sve pokazali i objasnili. Malo sam čekala termin, ali posao odrađen kako treba.",
    rating: 4.5,
    service: "Mali Servis",
  },
  {
    name: "Nikola Jovanović",
    car: "BMW 530d",
    comment: "Radili su mi veliki servis i zamenu ulja u automatskom menjaču. Auto menja brzine kao nov. Veoma profesionalni i pošteni sa cenama.",
    rating: 5.0,
    service: "Veliki Servis",
  },
  {
    name: "Stefan Đorđević",
    car: "Volkswagen Golf VII",
    comment: "Brza dijagnostika i zamena kočionih diskova pre puta na more. Dečki rade pedantno, a radionica izgleda vrhunski čisto.",
    rating: 4.8,
    service: "Kočnice",
  },
  {
    name: "Miloš Stanković",
    car: "Fiat Ducato",
    comment: "Prevoz kombija od Novog Sada do Beograda bez ikakvih problema. Cena dogovorena unapred i nije bilo iznenađenja. Jedino bi dolazak mogao malo brži.",
    rating: 4.2,
    service: "Prevoz Teretnog",
  },
  {
    name: "Ana Simić",
    car: "Toyota Corolla",
    comment: "Centriranje trapa i balansiranje guma — auto više ne vuče u stranu ni na autoputu. Ljubazni i precizni, vratiću se sigurno.",
    rating: 4.7,
    service: "Vulkanizer",
  },
  {
    name: "Dragan Ilić",
    car: "Mercedes Sprinter",
    comment: "Havarija na putu sa punim kombijem robe. Došli sa većim kamionom, prebacili teret i vozilo bez drame. Profesionalci.",
    rating: 4.9,
    service: "Šlep Teretnog",
  },
  {
    name: "Ivana Pavlović",
    car: "Opel Astra K",
    comment: "Detailing enterijera posle dvoje male dece — izgleda kao iz salona. Sedišta, plafon, sve. Vredelo je svakog dinara.",
    rating: 4.6,
    service: "Detailing",
  },
  {
    name: "Vladimir Kostić",
    car: "Peugeot 308",
    comment: "Kompjuterska dijagnostika je odmah našla grešku koju su mi u dva servisa 'pogađali'. Zamenjen senzor i auto radi savršeno.",
    rating: 4.4,
    service: "Dijagnostika",
  },
  {
    name: "Goran Milošević",
    car: "Ford Transit",
    comment: "Redovno šaljem celu flotu na održavanje kod njih. Termin se poštuje, faktura jasna, komunikacija odlična.",
    rating: 4.9,
    service: "Flota",
  },
];

function Stars({ rating }) {
  return (
    <div className="relative inline-flex">
      <div className="flex gap-1">
        {Array.from({ length: 5 }).map((_, s) => (
          <Star key={s} size={14} className="text-zinc-700" />
        ))}
      </div>
      <div className="absolute inset-0 overflow-hidden" style={{ width: `${(rating / 5) * 100}%` }}>
        <div className="flex gap-1">
          {Array.from({ length: 5 }).map((_, s) => (
            <Star key={s} size={14} className="text-amber-400 fill-amber-400 shrink-0" />
          ))}
        </div>
      </div>
    </div>
  );
}

function ReviewCard({ r, testid }) {
  return (
    <figure
      data-testid={testid}
      className="w-[340px] sm:w-[380px] shrink-0 bg-[#121216] border border-white/[0.07] rounded-2xl p-6 hover:border-red-600/35 transition-colors flex flex-col"
    >
      <div className="flex items-center justify-between">
        <Quote size={24} className="text-red-600/40" />
        <div className="flex items-center gap-2">
          <Stars rating={r.rating} />
          <span className="text-xs font-bold text-amber-400">{r.rating.toFixed(1).replace(".", ",")}</span>
        </div>
      </div>
      <blockquote className="text-sm text-zinc-300 leading-relaxed mt-4 flex-1">„{r.comment}"</blockquote>
      <figcaption className="mt-5 pt-4 border-t border-white/[0.07] flex items-center justify-between gap-3">
        <div className="min-w-0">
          <div className="flex items-center gap-1.5 text-white font-semibold text-sm">
            <span className="truncate">{r.name}</span> <BadgeCheck size={14} className="text-red-500 shrink-0" />
          </div>
          <div className="text-xs text-zinc-500 mt-0.5 truncate">{r.car}</div>
        </div>
        <span className="shrink-0 text-[10px] font-bold tracking-wider uppercase text-red-400/80 bg-red-600/10 border border-red-600/20 px-2.5 py-1 rounded-full">
          {r.service}
        </span>
      </figcaption>
    </figure>
  );
}

export default function Testimonials() {
  const row = [...REVIEWS, ...REVIEWS];
  return (
    <section id="recenzije" data-testid="testimonials-section" className="relative py-24 lg:py-32 bg-[#0c0c0f] overflow-hidden">
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none">
        <span className="font-display uppercase text-[18vw] leading-none text-white/[0.025] whitespace-nowrap">AutoBay</span>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14"
        >
          <div>
            <span className="text-red-500 text-xs font-bold tracking-[0.3em] uppercase">Utisci klijenata</span>
            <h2 className="font-display uppercase text-4xl sm:text-5xl lg:text-6xl text-white mt-3">
              Šta Kažu <span className="text-red-500">Vozači</span>
            </h2>
          </div>
          <div className="flex items-center gap-3">
            <Stars rating={4.7} />
            <span className="text-sm text-zinc-400"><strong className="text-white">4,7</strong> prosečna ocena</span>
          </div>
        </motion.div>
      </div>

      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="relative marquee-hover-pause"
      >
        <div className="absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[#0c0c0f] to-transparent z-10 pointer-events-none" />
        <div className="absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[#0c0c0f] to-transparent z-10 pointer-events-none" />
        <div className="flex w-max animate-marquee-rtl gap-5 px-5">
          {row.map((r, i) => (
            <ReviewCard key={`${r.name}-${i}`} r={r} testid={i < REVIEWS.length ? `testimonial-card-${i + 1}` : undefined} />
          ))}
        </div>
      </motion.div>
    </section>
  );
}
